import { actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  frequenciesCount: null,
  frequenciesList: [],
  addonsDetail: {},
  addonsCount: null,
  addonsList: [],
  couponsDetail: {},
  couponsCount: null,
  couponsList: [],
  intentsCount: null,
  intentsList: [],
  plansDetail: {},
  plansCount: null,
  plansList: [],
  productsDetail: {},
  productsCount: null,
  productsList: [],
  subscriptionsDetail: {},
  subscriptionsCount: null,
  subscriptionsList: [],
  usagesCount: null,
  usagesList: [],
  retrieveLoader: false,
  createLoader: false,
  deleteLoader: false
}

export default {
  namespaced: true,
  state,
  actions: actionsAbstract,
  mutations: mutationsAbstract
}
